/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Basic serializer to pass CustomUser details to the front end.
 * Extend with any fields your app needs.
 * @export
 * @interface CustomUser
 */
export interface CustomUser {
    /**
     * 
     * @type {number}
     * @memberof CustomUser
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    readonly avatarUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    readonly getDisplayName: string;
}

/**
 * Check if a given object implements the CustomUser interface.
 */
export function instanceOfCustomUser(value: object): value is CustomUser {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    if (!('getDisplayName' in value) || value['getDisplayName'] === undefined) return false;
    return true;
}

export function CustomUserFromJSON(json: any): CustomUser {
    return CustomUserFromJSONTyped(json, false);
}

export function CustomUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'avatarUrl': json['avatar_url'],
        'getDisplayName': json['get_display_name'],
    };
}

  export function CustomUserToJSON(json: any): CustomUser {
      return CustomUserToJSONTyped(json, false);
  }

  export function CustomUserToJSONTyped(value?: Omit<CustomUser, 'id'|'avatar_url'|'get_display_name'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'email': value['email'],
    };
}

